export default "__VITE_ASSET__CtkhJIOg__"